export enum Feature {
  enableLogging = "enableLogging",
}
